import * as echarts from 'echarts/core';

// 引入柱状图图表，图表后缀都为 Chart
import { BarChart,PieChart,LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    LegendComponent,
    DataZoomComponent,
    MarkLineComponent,
    VisualMapComponent,
    MarkAreaComponent,
    GraphicComponent,
    BrushComponent,
    ToolboxComponent,
} from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import { SurfaceChart,Line3DChart } from 'echarts-gl/charts'; // 引入Surface图
import {
    Grid3DComponent,
} from 'echarts-gl/components';
// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer,
    LegendComponent,
    PieChart,
    DataZoomComponent,
    LineChart,
    MarkLineComponent,
    VisualMapComponent,
    MarkAreaComponent,
    SurfaceChart,
    GraphicComponent,
    BrushComponent,
    ToolboxComponent,
    Grid3DComponent,
    Line3DChart
]);

export default echarts
